_partial = require('lodash/partial')
_isNull = require('lodash/isNull')
_isString = require('lodash/isString')
_keys = require('lodash/keys')
_isObject = require('lodash/isObject')
_extend = require('lodash/extend')
xhr      = require('shared/lib/fetch-xhr')
dispatcher = require('shared/lib/dispatcher')
metrics = require('shared/lib/metrics.coffee')
config = require('shared/lib/tp_config.js')
cookies = require('shared/lib/cookies.coffee')

TRIES_LIMIT = 3

WL_SEARCH_PREFIX_URL = "tickets-api"
WL_SEARCH_URL = "apistp.com"
WL_SEARCH_RESULTS_URL = "/searches_results_united"
WL_SEARCH_REQUEST_URL = "/adaptors/chains/"

module.exports = (request_params, callbacks = {}) ->
    #private
    callbacks = _extend({
      "on_update": ->
      "on_finish": ->
      "on_error" : ->
      "on_abort" : ->
    }, callbacks)

    search_uuid = null
    region      = null
    _xhr        = null
    tries_count = 0

    abort = -> _xhr?.abort()

    stop_marker_received = (data) ->
      stop_marker = (_isObject(data) and _keys(data).length == 1)
      _isString(data) or _isNull(data) or stop_marker

    failed_with_500 = (res) ->
      not res or res?.statusCode.toString()[0] == '5'

    is_as_chain = (locale) ->
      locale && ['ru', 'uk', 'hy', 'tg', 'be', 'ce', 'kk', 'uz', 'uk', 'az'].indexOf(locale.toLowerCase()) != -1

    get_search_url = (search_uuid = null, locale=null, region = null) ->
      if search_uuid
        if not region
          url = "https://#{WL_SEARCH_PREFIX_URL}"
        else
          url = "https://#{WL_SEARCH_PREFIX_URL}.#{region}"

        url = url + ".#{WL_SEARCH_URL}#{WL_SEARCH_RESULTS_URL}?uuid=#{search_uuid}&#{Math.random()}"
      else
        chain = if is_as_chain(locale) then 'rt_search_native_format' else 'jetradar_rt_search_native_format'

        url = "https://#{WL_SEARCH_PREFIX_URL}.#{WL_SEARCH_URL}#{WL_SEARCH_REQUEST_URL}" + chain

      url

    on_receive = (req_params, err, res) =>
      return callbacks.on_abort() if res?.abort
      return if res?.statusCode == 0

      if res?.statusCode is 200
        tries_count = 0
        if res?.body?.meta?.uuid
          search_uuid = res.body.meta.uuid
          match = res.body.server_name.match(/^[^\.]+\.(.+?)\//);
          if match
            region = match[1]
            dispatcher.send('region_updated', region)
        data = []
        for item, index in [].concat(res.body)
          if stop_marker_received(item)
            callbacks.on_update(data)
            callbacks.on_finish(data)
            return
          data.push(item)
        callbacks.on_update(data)

        send_request(get_search_url(search_uuid, req_params.lang, region))
      else
        if tries_count < TRIES_LIMIT and failed_with_500(res)
          dispatcher.send('log_warning', "Trying to reconnect #{tries_count} times", 'yasen_client')
          send_request(res.url, res.method, req_params)
        else
          callbacks.on_error({status: res?.statusCode})

        metrics.reach_goal('SEARCH_RESPONSE_ERROR', {status: res?.statusCode})


    send_request = (url, method = "get", request_params = {}) ->
      tries_count++
      # FIXME: Fix if something will go wrong
      request_params.currency ||= window.TPWLCONFIG.currency
      request_params.locale = request_params.lang if request_params.lang
      request_params.debug = cookies.get 'yasen_debug'
      request_params.results_debug = cookies.get 'results_debug'

      headers =
        "X-Client-Type": "white_label"
        "X-Origin-Cookie": document.cookie

      if window.TPWLCONFIG?.ab?.version?
        headers["X-Whitelabel-Version"] = window.TPWLCONFIG.ab.version

      if window.TPWLCONFIG?.ab?.flag?
        headers["X-Whitelabel-Ab-Flag"] = window.TPWLCONFIG.ab.flag

      if window.TPWLCONFIG?.ab?.variant_key?
        headers["X-Whitelabel-Ab-Variant"] = window.TPWLCONFIG.ab.variant_key

      if window.TPWLCONFIG?.ab?.evaluation_id?
        headers["X-Whitelabel-Ab-Evaluation-Id"] = window.TPWLCONFIG.ab.evaluation_id

      _xhr = xhr({
          url: url
          json: request_params
          method: method
          headers: headers
        }, _partial(on_receive, request_params))

    send_request(get_search_url(null, request_params.lang), "post", request_params)

    #public
    stop: -> abort()
